<template>
    <section v-if="addtionalAttirbute && currentCarat">

        <div class="setting_details" v-if="addtionalAttirbute && currentCarat">
            <div class="mb-2 title_flex" @click="toggleRing()"
                v-if="['anniversary-ring', 'couple-bands-ring', 'band-ring', 'in-stock-ring', 'in-stock-pendant', 'in-stock-earring', 'hoop-earring'].includes(detailData.sub_type)">
                <div class="font-active">
                    <span @click="toggleDetails('setting')" v-if="detailData.sub_type !== 'hoop-earring'">{{
                        labelSettingDetail }}</span>

                    <span
                        v-if="currentMetal.shape != '' && !['hoop-earring', 'band-ring', 'anniversary-ring', 'couple-bands-ring'].includes(detailData.sub_type)">
                        & Accent details</span>

                    <!-- <span v-if="detailData.stone_one_shape != null"  @click="toggleDetails('cen_stone')" :class="{ 'active' : tabs.cen_stone }">Center Stone</span>  -->

                </div>
                <SvgHeaderSvg class="for_mobile" :type="dropring ? 'up' : 'down'" />
            </div>

            <div class="ring_data_flex" :class="dropring ? 'show' : 'hide'">

                <div class="ring_box" v-if="detailData.sub_type_1"
                    @click="showModal('styleBand', modalParams.styleBand.style1)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.sub_type_1 }}</h5>
                        <p class="mb-0">Style</p>
                    </div>
                    <div class="ring_box_right">
                        <img v-if="detailData.sub_type_1 !== 'classic'" width="100" height="72"
                            :src="'/loose_setting/' + lowercase(detailData?.sub_type_1) + '.svg'" alt="Style" />
                        <img v-else width="70" height="72"
                            :src="'/loose_setting/' + lowercase(detailData?.sub_type_1) + '.svg'" alt="Style" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>

                <div class="d-none vto-do-not-remove">
                    <span class="title">Design No.</span>
                    <span class="description">{{ currentMetal.main_sku }}</span>
                </div>

                <div class="ring_box"
                    v-if="['anniversary-ring', 'couple-bands-ring', 'band-ring', 'in-stock-ring'].includes(detailData.sub_type)"
                    @click="showModal('styleBand', modalParams.styleBand.band1)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 non_cap" v-if="['in-stock-ring'].includes(detailData.sub_type)">
                            {{ detailData.setting.min_width }} / {{ detailData.setting.max_width }} mm</h5>
                        <h5 class="title_h5 non_cap" v-else>{{ addtionalAttirbute.average_width }}</h5>
                        <p class="mb-0">Average Width</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="72" src="~/assets/loose_setting/bandwidth.svg" alt="band width" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>

                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0"
                    @click="showModal('carat', modalParams.carat.weight2)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.lot_weight }} Ct. Tw.</h5>
                        <p class="mb-0">Total Carat Weight</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="72" src="~/assets/presetdetails/total_ct_w.svg" alt="quantity" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>

                <!-- <div class="ring_box hoop_mod" v-if="detailData.sub_type === 'hoop-earring'">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">Hinged</h5>
                        <p class="mb-0">Back Type</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="120" height="72" src="/loose_setting/hinged.svg" alt="Back Type" />
                    </div>
                    <div class="top-icon">
                    </div>
                </div> -->
                <!-- To Be Upadted with hoop based -->
                <!-- <ModalSettingStyle /> -->
                <!-- <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.side_stone_shape }}</h5>
                        <p class="mb-0">Shape</p>
                    </div>
                    <div class="ring_box_right pe-md-1">
                        <img v-if="currentMetal.shape.trim().split(/\s+/).length === 1" width="72" height="65" :src="`/loose_setting/${currentMetal.shape.toLowerCase()}.svg`" alt="Shape" />

                        <img v-else width="120" height="72" src="/loose_setting/diamond.svg" alt="Diamond" />
                    </div>
                    <div class="top-icon">
                        <ModalSettingShape :currentMetal="currentMetal.shape" title="Shape"/>
                    </div>
                </div> -->
                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0"
                    @click="showModal('carat', modalParams.carat.sidestone)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.num_side_lots }}</h5>
                        <p class="mb-0">Side Stone Quantity</p>
                    </div>
                    <div class="ring_box_right">
                        <img v-if="['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(detailData.sub_type)"
                            src="~/assets/loose_setting/diamond.svg" alt="Diamond">

                        <img v-else width="65" height="72"
                            :src="'/loose_setting/' + lowercase(detailData.setting.side_stone_shape) + '.svg'"
                            alt="carat" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>

                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0"
                    @click="showModal('colorClarity', modalParams?.colorClarity?.sidecolor)">
                    <div class="ring_box_left">
                        <h5 class="title_h5 caps">{{ detailData.setting.d_color }}</h5>
                        <p class="mb-0">Side Stone <br>Color</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                            :src="'/loose_setting/' + lowercase(detailData?.setting?.d_color) + '.svg'" alt="color" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>


                <div class="ring_box" v-if="detailData.setting && detailData.setting.side_lot_weight != 0"
                    @click="showModal('colorClarity', modalParams?.colorClarity?.sideclarity)">
                    <div class="ring_box_left">
                        <h5 class="title_h5"> {{ detailData.setting.d_clarity }}</h5>
                        <p class="mb-0">Side Stone <br>Clarity</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                            :src="'/loose_setting/' + lowercase(detailData.setting.d_clarity) + '.svg'"
                            alt="Diamond Clarity" />
                    </div>
                    <div class="top-icon">
                        <SvgHeaderSvg :type="'ask'" />
                    </div>
                </div>


            </div>
        </div>
        <!-- test commit -->

        <!-- Below Lies Instock Diamond Details -->
        <div class="diam_one mt-4 mt-md-5" v-if="['in-stock-ring', 'in-stock-pendant'].includes(detailData.sub_type)">
            <div class=" mb-3 title_flex" @click="toggleSingle()">
                <div class="font-active">
                    <span>Diamond Details </span>
                </div>
                <SvgHeaderSvg class="for_mobile" :type="drowdown ? 'up' : 'down'" />
            </div>

            <div class="ring_data_flex" :class="drowdown ? 'show' : 'hide'">
                <div class="ring_box" @click="showModal('diamond', modalParams.dia1.dcarat1)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData?.stone_one_weight }} Ct</h5>
                        <p>Carat</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                            :src="'/loose_setting/' + lowercase(detailData?.stone_one_shape) + '.svg'" alt="carat" />
                    </div>
                    <div class="top-icon">
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <div class="ring_box" @click="showModal('diamond', modalParams.dia1.dclarity1)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.stone_one_clarity }}</h5>
                        <p>Clarity</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                            :src="'/loose_graphics/clarity/' + lowercase(detailData.stone_one_clarity) + '.svg'"
                            alt="Diamond Clarity" />
                    </div>
                    <div class="top-icon">
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <div class="ring_box" @click="showModal('diamond', modalParams.dia1.dcolor1)">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData?.stone_one_color }}</h5>
                        <p>Color</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100"
                            :src="'/loose_graphics/color/' + lowercase(detailData.stone_one_color) + '.svg'"
                            alt="color" />
                    </div>
                    <div class="top-icon">
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div>
                <!-- <div class="ring_box">
                    <div class="ring_box_left">
                        <h5 class="mb-1">{{ detailData.cut_grade }}</h5>
                        <p>Cut</p>
                    </div>
                    <div class="ring_box_right">
                        <img width="100" height="100" :src="'/loose_graphics/newcut/' + lowercase(detailData.cut_grade) + '.svg'"
                            alt="cut" />
                    </div>
                    <div class="top-icon" @click="showModal(diamondParameters.cut)">
                        <span class="svgask">
                            <SvgHeaderSvg :type="'ask'" />
                        </span>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="ear_diam_block mt-4 mt-md-5" v-else-if="detailData?.sub_type === 'in-stock-earring'"
            :class="{ 'd-flex': filteredDiamonds[1], 'flex-column': !filteredDiamonds[1] }">
            <!-- Diamond & Diamond 1 & 2  -->
            <div class="earr_one" v-if="filteredDiamonds[0]">
                <div class="mb-3 title_flex" @click="toggleEar()">
                    <div class="font-active" :class="{ 'ring_border': filteredDiamonds[1] }">
                        <span v-if="!filteredDiamonds[1]">Diamond Details</span>
                        <span v-else>Diamond 1 Details</span>
                    </div>
                    <SvgHeaderSvg class="for_mobile" :type="eardropw ? 'up' : 'down'" />
                </div>

                <div class="ring_data_flex" :class="{
                    'nowrap': true,
                    'flex-wrap': filteredDiamonds[1],
                    'ring_border': filteredDiamonds[1],
                    'show': eardropw,
                    'hide': !eardropw
                }">
                    <div class="ring_box ring_box_mod" :class="{ 'wide-box': !filteredDiamonds[1] }"
                        @click="showModal('diamond', modalParams.dia1.dcarat1)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[0]?.weight }} Ct. Tw.</h5>
                            <p class="mb-0">Carat</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="72" height="72"
                                :src="'/loose_setting/' + lowercase(filteredDiamonds[0]?.shape) + '.svg'" alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>
                    <div class="ring_box ring_box_mod" :class="{ 'wide-box': !filteredDiamonds[1] }"
                        @click="showModal('diamond', modalParams?.dia1?.dclarity1)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[0]?.clarity }}</h5>
                            <p class="mb-0">Clarity</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="95" height="72"
                                :src="'/loose_graphics/clarity/' + lowercase(filteredDiamonds[0]?.clarity) + '.svg'"
                                alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>
                    <div class="ring_box ring_box_mod" :class="{ 'wide-box': !filteredDiamonds[1] }"
                        @click="showModal('diamond', modalParams.dia1.dcolor1)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[0]?.color }}</h5>
                            <p class="mb-0">Color</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="95" height="72"
                                :src="'/loose_graphics/color/' + lowercase(filteredDiamonds[0]?.color) + '.svg'"
                                alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else></div>

            <div class="earr_two" v-if="filteredDiamonds[1]">
                <div class="mb-3 title_flex" @click="toggleEar1()">
                    <div class="font-active">
                        <span>Diamond 2 Details</span>
                    </div>
                    <SvgHeaderSvg class="for_mobile" :type="eardropw1 ? 'up' : 'down'"  />
                </div>
                <div class="ring_data_flex" :class="eardropw1 ? 'show' : 'hide'">
                    <div class="ring_box ring_box_mod" @click="showModal('diamond2', modalParams?.dia2?.dcarat2)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[1]?.weight }} ct. tw.</h5>
                            <p class="mb-0">Carat</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="72" height="72"
                                :src="'/loose_setting/' + lowercase(filteredDiamonds[1]?.shape) + '.svg'" alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>
                    <div class="ring_box ring_box_mod" @click="showModal('diamond2', modalParams.dia2.dclarity2)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[1]?.clarity }}</h5>
                            <p class="mb-0">Clarity</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="95" height="72"
                                :src="'/loose_graphics/clarity/' + lowercase(filteredDiamonds[1]?.clarity) + '.svg'"
                                alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>

                    <div class="ring_box ring_box_mod" @click="showModal('diamond2', modalParams?.dia2?.dcolor2)">
                        <div class="ring_box_left">
                            <h5 class="mb-1">{{ filteredDiamonds[1]?.color }}</h5>
                            <p class="mb-0">Color</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="95" height="72"
                                :src="'/loose_graphics/color/' + lowercase(filteredDiamonds[1]?.color) + '.svg'"
                                alt="color" />
                        </div>
                        <div class="top-icon">
                            <span class="svgask">
                                <SvgHeaderSvg :type="'ask'" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else></div>
        </div>
        <div v-else>
            <!-- Below Lies Diamond Details -->
            <div class="setting_details mt-md-5" v-if="currentMetal?.shape != ''">

                <div class="mb-2 title_flex" @click="toggleSingle()">
                    <div class="font-active">
                        <span>Diamond details</span>
                    </div>
                    <SvgHeaderSvg class="for_mobile" :type="drowdown ? 'up' : 'down'" />
                </div>

                <div class="ring_data_flex" :class="drowdown ? 'show' : 'hide'">
                    <div class="ring_box" @click="showModal('carat', modalParams?.carat?.weight1)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ currentCarat?.value }} ct. tw.</h5>
                            <p class="mb-0">Min. Total Carat</p>
                        </div>
                        <div class="ring_box_right">
                            <img width="100" height="72" src="~/assets/loose_setting/totalctwt.svg" alt="Total CT WT" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>

                    <div class="ring_box" @click="showModal('colorClarity', modalParams?.colorClarity?.sidecolor)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ currentCarat?.d_color }}</h5>
                            <p class="mb-0">Average Color</p>
                        </div>
                        <div class="ring_box_right mt-md-2">
                            <img width="100" height="72"
                                :src="'/loose_setting/' + lowercase(currentCarat?.d_color) + '.svg'"
                                alt="Side Stone Color" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>

                    <div class="ring_box" @click="showModal('colorClarity', modalParams?.colorClarity?.sideclarity)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ currentCarat?.d_clarity }}</h5>
                            <p class="mb-0">Average Clarity</p>
                        </div>
                        <div class="ring_box_right mt-md-2">
                            <img width="100" height="72"
                                :src="'/loose_setting/' + lowercase(currentCarat?.d_clarity) + '.svg'" alt="Style" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>

                    <div class="ring_box" @click="showModal('carat', modalParams.carat.quantity)">
                        <div class="ring_box_left">
                            <h5 class="title_h5 caps">{{ addtionalAttirbute?.num_lots }}</h5>
                            <p class="mb-0">Diamond Quantity</p>
                        </div>
                        <div class="ring_box_right pe-md-1">
                            <img v-if="currentMetal.shape.trim().split(/\s+/).length === 1" width="72" height="65"
                                :src="`/loose_setting/${lowercase(currentMetal.shape)}.svg`" alt="Shape" />

                            <img v-else width="100" height="72" src="~/assets/loose_setting/diamond.svg"
                                alt="Diamond" />
                        </div>
                        <div class="top-icon">
                            <SvgHeaderSvg :type="'ask'" />
                        </div>
                    </div>

                </div>

            </div>
        </div>


        <section class="tableSection mt-3" v-if="detailData?.sub_type == 'roses-portraits-ring'">
            <div class="table_skeleton" v-if="loader">
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
                <div class="placeholder skeleton"></div>
            </div>

            <div :class="{'fullFancy' : tableData.length}" v-if="!loader && tableData">
                <div :class="index === 0 ? 'headers' : 'cell'" v-for="(d,index) in tableData" :key="d.id">
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col1)">{{ d.col1 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col2)">{{ d.col2 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col3)">{{ d.col3 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col4)">{{ d.col4 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col5)">
                        <span v-if="index === 0">{{ tableData[0].col5 }}</span>
                        <span :class="d.col5" v-else>{{$formatExactCarat(d.col5)}} ct. tw</span>
                    </p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col6)">{{ d.col6 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col7)">{{ d.col7 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col8)">{{ d.col8 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col9)">{{ d.col9 }}</p>
                    <p class="mb-0" v-if="!['', null].includes(tableData[0].col10)">{{ d.col10 }}</p>
                </div>
            </div>

        </section>



        <div class="mt-3 mt-md-4" v-if="currentCarat">
            <div class="ring_title mb-2 ms-md-2">
                <span class="prod_title">{{ currentCarat.product_name }}</span>
                <span class="for_desktop"> | </span>
                <span class="prod_sku">SKU : {{ currentMetal.main_sku }}</span>
            </div>
            <div class="ring_desc ms-md-2">
                <span>{{ currentCarat.long_desc }}</span>
            </div>
        </div>

        <CommonCustomModal v-model="flagShowModal" :size="'sm'">

            <div v-for="(isOpen, type) in modalFlags" :key="type">
                <ModalCover v-if="isOpen" :id="`modal-${modalBoxes[type]}`" :type="type" :boxValue="modalBoxes[type]"
                    :item="detailData" :addtionalAttirbute="addtionalAttirbute" :params="modalParams"
                    :currentCarat="currentCarat" :currentMetal="currentMetal" :currentColor="currentCarat.d_color"
                    :currentClarity="currentCarat?.d_clarity" :detailData="detailData" />

                <ModalDiamondModal v-if="isOpen" :id="`modal-${modalBoxes[type]}`" :type="type"
                    :boxValue="modalBoxes[type]" :dData="detailData" />
            </div>

        </CommonCustomModal>

    </section>
</template>

<script setup>

import { shopdetailStore } from '@/stores/shop_detail/shop_detail';
const store = shopdetailStore()
const dropring = ref(true);
const eardropw = ref(true);
const eardropw1 = ref(true);
const drowdown = ref(true);
const route = useRoute()
const flagShowModal = ref(false);

const tableData = ref([]);
const loader = ref(false);

const tabs = reactive({
    setting: true,
    cen_stone: false,
    accent_stone: false,
})
const toggleRing = () => {
    dropring.value = !dropring.value;

};
const toggleEar = () => {
    eardropw.value = !eardropw.value
}
const toggleEar1 = () => {
    eardropw1.value = !eardropw1.value
}
const lowercase = (value) => {
    return value?.toLowerCase().replace(/[^\w\s]/gi, '');
}
const toggleSingle = () => {
    drowdown.value = !drowdown.value;
};

const detailData = computed(() => {
    return store.getDetailData
})

const currentMetal = computed(() => {
    return store.getCurrentActive('metal')
})

const currentCarat = computed(() => {
    return store.getCurrentActive('carat')
})

const addtionalData = computed(() => {
    return store.getAdditionalDetails
})

const labelSettingDetail = computed(() => {

    const sub_type = detailData.value.sub_type

    const rings = ['full-eternity-ring', 'toi-et-moi-ring', 'anniversary-ring', 'couple-bands-ring', 'band-ring']
    const eng_rings = ['engagement-ring', 'in-stock-ring', 'in-stock-pendant', 'in-stock-earring']
    const bracelets = ['tennis-bracelet']
    const necklaces = ['tennis-necklace', 'solitaire-necklace', 'fashion-necklace']
    const studs = ['earring', 'stud-earring', 'fashion-earring']
    const hoops = ['hoop-earring']

    if (!sub_type) {

        return ''
    } else if (rings.includes(sub_type)) {

        return 'Band Details'
    }
    else if (eng_rings.includes(sub_type)) {

        return 'Setting Details'
    }
    else if (bracelets.includes(sub_type)) {

        return 'Bracelet Details'
    }
    else if (necklaces.includes(sub_type)) {

        return 'Necklace Details'
    }
    else if (studs.includes(sub_type)) {

        return 'Stud Details'
    }
    else if (hoops.includes(sub_type)) {

        return 'Hoop Details'
    }
    return ''

})

const currentSize = computed(() => {
    let type
    if (['tennis-necklace', 'fashion-necklace', 'solitaire-necklace', 'tennis-bracelet'].includes(detailData.value.sub_type)) {
        type = 'chain_length'
    }

    if (['stud-earring' , 'fashion-earring' ,'in-stock-earring'].includes(detailData.value.sub_type)) {
        type = 'back_type'
    }
    if (['full-eternity-ring', 'toi-et-moi-ring', 'band-ring', 'anniversary-ring'].includes(detailData.value.sub_type)) {
        type = 'size'
    }
    if (['openable-bangle'].includes(detailData.value.sub_type)) {
        type = 'diameter'
    }
    if (['couple-bands-ring'].includes(detailData.value.sub_type)) {
        type = 'his_size'
    }

    return store.getCurrentActiveAttribute(type)
})

const addtionalAttirbute = computed(() => {
    let size = null
    if (currentSize.value) {
        size = currentSize.value.value
    }
    if (addtionalData.value && size !== undefined) {

        const filteredData = addtionalData.value.find(cv => cv.size_attribute == size)

        if (filteredData !== undefined) {

            return filteredData
        }
    }
    if (currentCarat.value !== undefined) {

        return currentCarat.value
    }

    return null
})

const numLots = computed(() => {

    const filteredData = addtionalAttirbute.value

    if (filteredData !== null) {

        return filteredData.num_lots
    }

    if (currentCarat.value !== undefined) {

        return currentCarat.value.num_lots
    }

    return ''

})

const id = detailData?.value?.main_sku;

function toggleDetails(type) {
    tabs.setting = false
    tabs.accent_stone = false
    tabs.cen_stone = false

    tabs[type] = true
}

const filteredDiamonds = computed(() => {
  const diamonds = detailData?.value?.diamonds || [];
  return diamonds
    .filter(diamond => diamond?.weight && diamond?.shape)
    .map(diamond => ({
      weight: diamond?.weight || '',
      shape: diamond?.shape || '',
      clarity: diamond?.clarity || '',
      color: diamond?.color || '',
    }));
});

const dropdowns = reactive({
    1: false,
    2: false
});

function toggleBox(diamondNumber) {
    dropdowns[diamondNumber] = !dropdowns[diamondNumber];
}

const modalFlags = ref({
    styleBand: false,
    colorClarity: false,
    carat: false,
    diamond: false,
    diamond2: false,
});

const modalBoxes = ref({
    styleBand: '',
    colorClarity: '',
    carat: '',
    diamond: '',
    diamond2: '',
});

const modalParams = {
    styleBand: { style1: 'style1', band1: 'band1' },
    colorClarity: { sidecolor: 'sidecolor', sideclarity: 'sideclarity' },
    carat: { weight1: 'weight1', weight2: 'weight2', sidestone: 'sidestone', quantity: 'quantity' },
    dia1: { dcarat1: 'dcarat1', dcut1: 'dcut1', dcolor1: 'dcolor1', dclarity1: 'dclarity1' },
    dia2: { dcarat2: 'dcarat2', dcut2: 'dcut2', dcolor2: 'dcolor2', dclarity2: 'dclarity2' },
};

const showModal = (type, boxValue) => {
    Object.keys(modalFlags.value).forEach((modalType) => {
        modalFlags.value[modalType] = false;
        modalBoxes.value[modalType] = '';
    });

    // Activate the specified modal.
    modalFlags.value[type] = true;
    modalBoxes.value[type] = boxValue;
    flagShowModal.value = true;
};


const getDetail = async () => {
    if (detailData?.value?.sub_type === 'roses-portraits-ring') {
        loader.value = true;
        try {
            const res = await $fetch(useCountryPath(`config/shop/jewelry-detail/${id}`))
            tableData.value = res.data;
        } catch (error) {
            console.log(error);
        } finally {
            loader.value = false;
        }
    }
};

onMounted(async () => {
    await store.setAdditionalDetails({ slug: route.params.slug });
    await getDetail();
})

</script>

<style scoped>
.ear_diam_block {
    display: flex;
    justify-content: center;

}

.ear_diam_block .ring_data_flex {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
}

.ear_diam_block .ring_data_flex .ring_box_mod {
    width: 44%
}

.ear_diam_block .ring_data_flex .ring_box_mod.wide-box {
    width: 23%;
}

.ear_diam_block .ring_data_flex.nowrap {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: nowrap;

}

.ear_diam_block .ring_data_flex .ring_border.nowrap {
    border: 0;
}

.ring_border {
    border-right: 2px dashed #c4c4c4;
}

.title_flex {
    font-size: 28px;
    text-align: center;
    color: #242529;
    text-transform: capitalize;
}

.ring_data_flex {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
}

.ring_box {
    width: 23%;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    margin: 10px;
    padding: 13px;
    position: relative;
    display: flex;
    align-items: flex-start;
    min-height: 100px;
    cursor: pointer;
}

.hoop_mod {
    cursor: default;
}

.top-icon {
    position: absolute;
    top: 4px;
    right: 2px;
    cursor: pointer;
}

.ring_box_left {
    width: 60%;
}

.ring_box_right {
    width: 40%;
    text-align: right;
}

h5 {
    font-size: 20px;
    color: #212529;
    text-transform: capitalize;
    font-weight: 600;
    margin-bottom: 5px;
}

.ring_box_left p {
    font-size: 14px;
    color: #606060;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.ring_desc {
    font-size: 16px;
    color: #606060;
}

.prod_sku {
    font-size: 16px;
    color: #606060;
}

.prod_title {
    font-size: 16px;
    color: #353535;
    font-weight: 600;
}

.non_cap {
    text-transform: lowercase;
}
/* Table */
.tableSection {
    overflow-x: auto;
}

.table_skeleton {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.skeleton {
  height: 32px;
  width: 1180px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.3);
  mask-image: radial-gradient(white, black);
  cursor: wait;
  overflow: hidden;
  margin-bottom: 10px;
}
.fullFancy{
    overflow-x: auto;
    width: 1180px;
    margin: 0 auto;
    text-align: center;
    border-radius: 4px;
    /* padding-bottom: 5px; */
    margin-bottom: 5px;
    border: 1px solid #c4c4c4;
}
.headers, .cell{
    display: flex;
}
.headers{
    background: #f5f5f5;
    font-weight: 600;
}
.headers p , .cell p {
    width: 25%;
    padding: 4px;
    border-right: 1px solid #c4c4c4;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cell p{
    color: #353535;
    font-weight: 500;
}
.headers , .cell {
    border-bottom: 1px solid #c4c4c4;
}
.headers p:last-child , .cell p:last-child {
    border-right: 0;
    
}
.cell:last-child{
    border-bottom: 0;
}
@media(max-width: 1250px) {

    .table_text {
        padding-left: 0;
    }
}

@media(max-width: 1150px) {
    .ring_box {
        margin: 5px;
    }

    .tableSection {
        padding-left: 20px;
    }

    h5 {
        font-size: 16px;
    }

    .ear_diam_block {
        display: flex;
        flex-direction: column;
    }

    .ring_border {
        border-right: none;
    }

    .ear_diam_block .ring_data_flex {
        width: 100%;
    }
    .ear_diam_block .ring_data_flex .ring_box_mod {
        width: 28%;
    }
}

@media(max-width: 992px) {
    .ring_data_flex {
        flex-wrap: wrap;
        /* justify-content: space-between; */
    }

    .tableSection {
        padding-left: 0;
    }

    .ring_box {
        width: 31%;
        margin: 7px;

    }

    .ring_box .ring_box_mod {
        width: 100%;
    }
}

@media(max-width: 767px) {
    .ring_data_flex.hide {
        display: none;
    }
    .ear_diam_block .ring_data_flex .ring_box_mod {
    width: 48%;
}
    .ear_diam_block .ring_data_flex.nowrap.hide {
        display: none;
    }

    .ear_diam_block .ring_data_flex .ring_box_mod.wide-box {
        width: 48%;
    }

    .ring_data_flex {
        justify-content: space-between;
    }

    .ear_diam_block .ring_data_flex {
        justify-content: space-between;
    }

    .ear_diam_block .ring_data_flex.nowrap {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .ring_box {
        width: 48%;
        flex-wrap: wrap;
        flex-direction: column-reverse;
        padding: 13px 5px;
        margin: 6px 0;
        min-height: 155px;
    }

    .ring_box_left,
    .ring_box_right {
        width: 100%;
        text-align: center;
    }

    .ring_box_left p {
        font-size: 12px;
    }

    .title_flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
    }

    .ring_box_left {
        margin-top: 10px;
    }

    .prod_title,
    .prod_sku,
    .ring_desc {
        font-size: 14px;
        display: block;
    }
}
</style>